module.exports = __webpack_public_path__ + "img/42_11.f122d5c6.png";